import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { AuthService } from '../../../../../../services/auth.services'
import { RestServices } from '../../../../../../services/rest.services'
import { ModalService } from '../../../../../../services/modal.service'
import { SharedServices } from '../../../../../../services/shared.services'
import { ClientTopServices } from '../../../../../../services/ClientTop.services'
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms'
import { getImageRedirectUrl } from '../../../../../../../helper/common'
import { MatrixServices } from '../../../../../../services/image/matrix.services'
import { StateServices } from '../../../../../../services/state.services'
import * as $ from 'jquery'


@Component({
    selector: 'app-modal-client-detail-top-registraion-other',
    templateUrl: './modal-client-detail-registraion-other.component.html',
    styleUrls: [
        '../../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../../stagingcss/ui-schema-table-form.component.css',
        '../../../../../../stagingcss/main-body.component.css',
        '../../../../../../stagingcss/lui-select.component.css',
        './modal-client-detail-registraion-other.component.css',
        '../../../../../../stagingcss/image-viewer.component.css',
    ],
})
export class ModalClientDetailRegistraionOtherComponent implements OnInit, OnDestroy {
    en = {}
    showEN = true
    option_RegistrationOther: String = 'active'
    TabRegistrationOtherClass
    status: Boolean = false
    arrRegistrationOther: any[] = []
    statusImage: String = ''
    arrSlideshowTooth
    arrTabRegistrationOther = [
        { id: 0, name: 'All', nameSave: 'Registration-All' },
        { id: 1, name: '1', nameSave: 'Registration-Tooth-Front-Right' },
        { id: 2, name: '2', nameSave: 'Registration-Tooth-Front-Front' },
        { id: 3, name: '3', nameSave: 'Registration-Tooth-Side-Left' },
        { id: 4, name: '4', nameSave: 'Registration-Tooth-Side-Upper' },
        { id: 5, name: '5', nameSave: 'Registration-Tooth-Overjet' },
        { id: 6, name: '6', nameSave: 'Registration-Tooth-Lower' },
    ]
    option_Registration: String = 'active'
    senMax: any = 100
    max: any = 5

    arrAllOther: any[] = []
    jsonOther: any = {}

    index: any

    arrShowStatus: any[] = []
    tabName: any = 'other-all'
    uploadImageForm: FormGroup
    width: any
    height: any
    imageAddHeight: any
    imageAddWidth: any
    valChange: any = 0
    matrixImage: any[] = []
    arrImage: any[] = []
    emitTabName: any = {}
    emitArrAll: any = {}
    animationDuration: any
    arrLoading: any[] = []
    arrStyle: any[] = [{}, {}, {}, {}, {}, {}]
    isEmptyArray: Boolean = false
    resourceUrl = 'resource'
    countRecrond
    tabUploadImage: any
    ValueAssignOneDistance: any = 0
    @ViewChild('imageWrapper') imageWrapper: ElementRef
    @ViewChild('imageId') imageId: ElementRef
    oldHeight: any
    oldWidth: any

    defaultArrayTypeImage: any[] = ['large', 'large', 'large', 'large', 'large', 'large']
    arrayTypeImage: any[] = ['large', 'large', 'large', 'large', 'large', 'large']
    arrIds: any[] = []
    arrStyleImage = []
    unscrCopy
    unscrIndex
    unscrAllArrClientTop
    unscrArrHash

    getInfoIndex = undefined
    page = 'registration'
    unscrPage

    constructor(private _sharedService: SharedServices,
                private authData: AuthService,
                private restApi: RestServices,
                private formBuider: FormBuilder,
                private modalService: ModalService,
                private clientTopServices: ClientTopServices,
                public matrixServices: MatrixServices,
                private stateServices: StateServices) {
        this.option_RegistrationOther = 'active'
        this.TabRegistrationOtherClass = 'option_0'
    }

    ngOnInit() {
        this.resetMatrix()
        this.uploadImageForm = this.formBuider.group({
            requests: new FormArray([
                new FormControl(null),
                new FormControl(null),
                new FormControl(null),
                new FormControl(null),
                new FormControl(null),
                new FormControl(null),
            ]),
        })
        this.arrLoading = [true, true, true, true, true, true]
        // this.clientTopServices.changeEmittedTabName$.subscribe(infoTabName => {
        const infoTabName: any = this.clientTopServices.functReturnTabName()
        if (infoTabName != null && infoTabName['tabName'] != undefined) {
            this.tabName = infoTabName['tabName']
        } else {
            this.tabName = 'other-all'
        }
        const tmpStr: String = this.tabName
        if (tmpStr.includes('other')) {
            // this.clientTopServices.changeEmittedAllArrClientTo$.subscribe(arrAll => {
            this.getArrClientTop()
            // });
        }
        // });
        this.clientTopServices.changeEmittedStatus$.subscribe(res => {
            if (res != null && res['status'] != undefined) {
                this.status = res['status']
            } else {
                this.status = false
            }
        })
        if ($(window).innerWidth() != window.screen.width) {
            this.width = ($(window).innerWidth() - 300) / 3
            this.height = 2 * this.width / 3
        } else if ($(window).innerHeight() != window.screen.height) {
            const tmpH = $(window).innerHeight()
            this.height = (tmpH - 300) / 2
            this.width = this.height * 3 / 2
        }
        this.oldHeight = this.height
        this.oldWidth = this.width
        this.imageAddHeight = this.height / 6
        this.imageAddWidth = this.width / 6
        this.getArrHash()
        this.getStyle()
        this.resizeUser()
        this.resizeFullScreen()
        this.getPage()
    }

    ngOnDestroy() {
        this.getInfoIndex = undefined
        if(this.unscrPage)
            this.unscrPage.unsubscribe()
        if(this.unscrIndex)
            this.unscrIndex.unsubscribe()
        if(this.unscrAllArrClientTop)
            this.unscrAllArrClientTop.unsubscribe()
        if(this.unscrArrHash)
            this.unscrArrHash.unsubscribe()
    }

    getPage() {
        this.unscrPage = this.clientTopServices.changeEmiitedPage$.subscribe(res => {
            if (res) {
                this.page = res
            }
        })
    }


    resizeFullScreen() {
        this.clientTopServices.changeEmitted$.subscribe(screen => {
            if (screen != null && screen != undefined && screen['status'] != undefined) {
                if (screen['status'] == 'active') {
                    this.height = this.oldHeight
                    this.width = this.oldWidth
                } else if (screen['status'] == 'hidden') {
                    if ($(window).innerWidth() != window.screen.width) {
                        const tmpW = $(window).innerWidth()
                        this.width = (tmpW - 200) / 3
                        this.height = this.width * 2 / 3
                    } else if ($(window).innerHeight() != window.screen.height) {
                        const tmpH = $(window).innerHeight()
                        this.height = (tmpH - 200) / 2
                        this.width = this.height * 3 / 2
                    }
                }
                const _thi = this
                setTimeout(function() {
                    _thi.arrShowStatus.forEach((el, item) => {
                        if (el) {
                            const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + item)
                            const imageId: HTMLElement = document.getElementById('imageId' + item)
                            _thi.matrixServices.loadSizeImage(imageId, imageWrapper, item, _thi.matrixImage, _thi.arrImage, _thi.arrRegistrationOther)
                        }
                    })
                }, 10)
            }
        })
    }


    resetMatrix() {
        this.matrixServices.arrRotate = [0, 0, 0, 0, 0, 0]
        this.matrixServices.arrStyleImage = [0, 0, 0, 0, 0, 0]
        this.matrixServices.arrFlip = [
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
        ]
    }

    resizeUser() {
        this.clientTopServices.changeEmittedViewDetailUser$.subscribe(status => {
            const tmpStr: String = this.tabName
            if (tmpStr.includes('other')) {
                if (status != null && status['status'] != undefined) {
                    this.resetMatrix()
                    const tmp: any = status['status']
                    if (tmp == 'in') {
                        if ($(window).innerWidth() != window.screen.width) {
                            const tmpW = $(window).innerWidth()
                            this.width = (tmpW - 300) / 3
                            this.height = this.width * 2 / 3
                        } else if ($(window).innerHeight() != window.screen.height) {
                            const tmpH = $(window).innerHeight()
                            this.height = (tmpH - 500) / 2
                            this.width = this.height * 3 / 2
                        } else {
                            const tmpH = $(window).innerHeight()
                            this.height = (tmpH - 500) / 2
                            this.width = this.height * 3 / 2
                        }
                    } else {
                        if ($(window).innerWidth() != window.screen.width) {
                            const tmpW = $(window).innerWidth()
                            this.width = (tmpW - 300) / 3
                            this.height = this.width * 2 / 3
                        } else if ($(window).innerHeight() != window.screen.height) {
                            const tmpH = $(window).innerHeight()
                            this.height = (tmpH - 300) / 2
                            this.width = this.height * 3 / 2
                        }
                    }
                    this.oldHeight = this.height
                    this.oldWidth = this.width
                    const _thi = this
                    setTimeout(function() {
                        _thi.arrShowStatus.forEach((el, item) => {
                            if (el) {
                                const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + item)
                                const imageId: HTMLElement = document.getElementById('imageId' + item)
                                _thi.matrixServices.loadSizeImage(imageId, imageWrapper, item, _thi.matrixImage, _thi.arrImage, _thi.arrRegistrationOther)
                            }
                        })
                    }, 10)
                }
            }
        })
    }

    resetMatrixMovedUpPage() {
        const _thi = this
        setTimeout(function() {
            _thi.arrShowStatus.forEach((el, item) => {
                if (el) {
                    const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + item)
                    const imageId: HTMLElement = document.getElementById('imageId' + item)
                    if (imageId != undefined && imageWrapper != undefined) {
                        _thi.matrixServices.loadSizeImage(imageId, imageWrapper, item, _thi.matrixImage, _thi.arrImage, _thi.arrRegistrationOther)
                    }
                }
            })
        }, 10)
    }

    getArrClientTop() {
        this.getDataShow()
        this.getDataIndex()
    }

    getDataIndex() {
        this.unscrIndex = this.clientTopServices.changeEmittedIndex$.subscribe(infoIndex => {
            const tmpStr: String = this.tabName
            if (infoIndex != null && infoIndex['index'] != undefined && this.page == 'registration') {
                this.index = infoIndex['index']
                this.getInfoIndex = jQuery.extend(true, {}, infoIndex)
                if (tmpStr.includes('other') && this.arrAllOther.length > 0) {
                    this.max = this.arrAllOther.length - 1
                    if (this.max > 0) {
                        this.ValueAssignOneDistance = this.senMax / this.max
                        this.valChange = this.index * this.ValueAssignOneDistance
                    } else {
                        this.valChange = 0
                    }
                    this.arrLoading = [false, false, false, false, false, false]
                    if (this.arrAllOther[this.index] != undefined) {
                        this.jsonOther = this.arrAllOther[this.index]
                        this.initjsonMovie(this.arrAllOther[this.index])
                        this.animationDuration = 300
                    }
                }
            }
        })
    }

    getDataShow() {
        this.unscrAllArrClientTop = this.clientTopServices.changeEmittedAllArrClientTo$.subscribe(res => {
            const tmpStr: String = this.tabName
            if (res != null && res['registration'] != undefined && res['registration'].length > 0 && this.page == 'registration') {
                this.isEmptyArray = false
                this.arrAllOther = res['registration']
                this.countRecrond = res['registration'].length
                if (tmpStr.includes('other') && this.getInfoIndex) {
                    if (this.arrAllOther.length > 0) {
                        this.max = this.arrAllOther.length - 1
                        if (this.max > 0) {
                            this.ValueAssignOneDistance = this.senMax / this.max
                            this.valChange = this.index * this.ValueAssignOneDistance
                        } else {
                            this.valChange = 0
                        }
                        if (this.arrAllOther[this.index] != undefined) {
                            this.jsonOther = this.arrAllOther[this.index]
                            this.initjsonMovie(this.arrAllOther[this.index])
                            this.animationDuration = 300
                        }
                    }
                }
            } else {
                this.countRecrond = 0
                this.isEmptyArray = true
                this.arrRegistrationOther = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
                this.getShowStatus(this.arrRegistrationOther)
            }
        })
    }

    // isEmptyArr() {
    //   this.clientTopServices.changeEmiitedIsCreated$.subscribe(create => {
    //     if (create != null && create['create'] != undefined) {
    //       const tab: any = create['tabName'];

    //       if (tab == this.tabName) {
    //         this.isEmptyArray = true;
    //         this.getArrClientTop();
    //       }
    //     }
    //   });
    // }

    // refresh() {
    //   this.clientTopServices.changeEmittedrefreshArr$.subscribe(refresh => {
    //     if (refresh != null && refresh['refresh'] != undefined) {
    //       const tab: any = refresh['tabName'];
    //       if (refresh['refresh'] == true && this.tabName == tab) {
    //         this.callApiInfoTopClient();
    //       }
    //     }
    //   });
    // }

    getArrCopy() {
        this.unscrCopy = this.clientTopServices.changeEmittedArrCopy$.subscribe(arCopy => {
            if (arCopy != null && arCopy['onCut'] != undefined) {
                if (arCopy['onCut'] == 'cut') {
                    const tab = arCopy['tabName']
                    if (this.tabName == tab) {
                        this.arrRegistrationOther = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
                        this.getShowStatus(this.arrRegistrationOther)
                        this.jsonOther[this.tabName] = this.arrRegistrationOther
                        this.arrAllOther[this.index] = this.jsonOther
                        const arrCopy: any[] = arCopy['arrCopy']
                        const tmp: any = arrCopy[0]['id'] ? arrCopy[0]['id'] : ''
                        const jsonTmp: any = {}
                        jsonTmp['id'] = tmp
                        if (arrCopy[0]['id'] != '') {
                            switch (this.tabName) {
                                case 'other-1':
                                    if (tmp != '') {
                                        this.jsonOther['other-all'][0] = jsonTmp
                                    }
                                    break
                                case 'other-2':
                                    if (tmp != '') {
                                        this.jsonOther['other-all'][1] = jsonTmp
                                    }
                                    break
                                case 'other-3':
                                    if (tmp != '') {
                                        this.jsonOther['other-all'][2] = jsonTmp
                                    }
                                    break
                                case 'other-4':
                                    if (tmp != '') {
                                        this.jsonOther['other-all'][3] = jsonTmp
                                    }
                                    break
                                case 'other-5':
                                    if (tmp != '') {
                                        this.jsonOther['other-all'][4] = jsonTmp
                                    }
                                    break
                                case 'other-6':
                                    if (tmp != '') {
                                        this.jsonOther['other-all'][5] = jsonTmp
                                    }
                                    break
                                case 'other-all':
                                    arrCopy.forEach((el, i) => {
                                        switch (i) {
                                            case 0:
                                                this.jsonOther['other-1'][0] = jsonTmp
                                                break
                                            case 1:
                                                this.jsonOther['other-2'][0] = jsonTmp
                                                break
                                            case 2:
                                                this.jsonOther['other-3'][0] = jsonTmp
                                                break
                                            case 3:
                                                this.jsonOther['other-4'][0] = jsonTmp
                                                break
                                            case 4:
                                                this.jsonOther['other-5'][0] = jsonTmp
                                                break
                                            case 5:
                                                this.jsonOther['other-6'][0] = jsonTmp
                                                break
                                            default:
                                                break
                                        }
                                    })
                                    break
                                default:
                                    break
                            }
                            this.arrAllOther[this.index] = this.jsonOther
                        }
                    }
                }
            }
        })
    }

    getStyle() {
        this.clientTopServices.changeEmittedStyle$.subscribe(style => {
            if (style != null && style['style'] != undefined) {
                const tab: any = style['tabName']
                if (tab == this.tabName) {
                    this.arrStyle = style['style']
                    if (this.arrStyle.length > 0) {
                        this.arrRegistrationOther = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
                        this.getShowStatus(this.arrRegistrationOther)
                        this.jsonOther[this.tabName] = this.arrRegistrationOther
                        this.arrAllOther[this.index] = this.jsonOther
                        this.emitArrAll['registration'] = this.arrAllOther
                        this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
                    } else {
                        const arrCopy: any[] = style['arrCopy']
                        this.arrRegistrationOther = arrCopy
                        this.getShowStatus(this.arrRegistrationOther)
                        this.jsonOther[this.tabName] = this.arrRegistrationOther
                        this.arrAllOther[this.index] = this.jsonOther
                    }
                }
            } else {
                this.arrStyle = [{}, {}, {}, {}, {}, {}]
            }
        })
    }

    getArrHash() {
        this.unscrArrHash = this.stateServices.changeEmittedHash$.subscribe(response => {
            if (response != null && response[this.tabName] != undefined && response[this.tabName].length > 0) {
                const tmpStr: String = this.tabName
                const arrRes: any[] = response[this.tabName]
                if (tmpStr.includes('other')) {
                    this.arrRegistrationOther = jQuery.extend(true, [], arrRes)
                    // arrRes.forEach((el, i) => {
                    //     this.arrRegistrationOther[i] = el;
                    // });
                    this.jsonOther[this.tabName] = this.arrRegistrationOther
                    this.arrAllOther[this.index] = this.jsonOther
                    const tmp: any = arrRes[0]
                    switch (this.tabName) {
                        case 'other-1':
                            this.arrAllOther[this.index]['other-all'][0] = tmp
                            break
                        case 'other-2':
                            this.arrAllOther[this.index]['other-all'][1] = tmp
                            break
                        case 'other-3':
                            this.arrAllOther[this.index]['other-all'][2] = tmp
                            break
                        case 'other-4':
                            this.arrAllOther[this.index]['other-all'][3] = tmp
                            break
                        case 'other-5':
                            this.arrAllOther[this.index]['other-all'][4] = tmp
                            break
                        case 'other-6':
                            this.arrAllOther[this.index]['other-all'][5] = tmp
                            break
                        case 'other-all':
                            arrRes.forEach((el, i) => {
                                const count = i + 1
                                const tabN = 'other-' + count
                                this.arrAllOther[this.index][tabN][0] = el
                            })
                            break
                        default:
                            break
                    }
                    this.emitArrAll['registration'] = this.arrAllOther
                    this.emitArrAll['checkChange'] = true
                    this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
                }
            }
        })
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        if (event.target.innerWidth != window.screen.width) {
            const tmpW = event.target.innerWidth
            this.width = (tmpW - 300) / 3
            this.height = this.width * 2 / 3
        } else if (event.target.innerHeight != window.screen.height) {
            const tmpH = event.target.innerHeight
            this.height = (tmpH - 300) / 2
            this.width = this.height * 3 / 2
        }
        this.oldHeight = this.height
        this.oldWidth = this.width
    }

    // getValueSlider() {
    //   this.clientTopServices.changeEmittedValueSlider$.subscribe(res => {
    //     if (res != null && res['sliderClientTop'] != undefined) {
    //       this.valChange = res['sliderClientTop'];
    //     }
    //   });
    // }

    changeValueEx1SliderRegister(valueUsageChange) {
        const value: any = valueUsageChange
        if (this.max > 0) {
            const tmp: number = (value / this.senMax) * this.max
            this.index = Math.round(tmp)
            const tmpEarch: number = this.senMax / this.max
            const assignCalculate = Math.round(tmpEarch)
            const assign = this.index * assignCalculate
            // if (this.arrAllOther[this.index] != undefined) {
            //     this.jsonOther = this.arrAllOther[this.index];
            //     this.initjsonMovie(this.jsonOther);
            //     this.arrRegistrationOther = this.jsonOther[this.tabName];
            // }
            // this.valChange = assign;
            const valueSlider: any = {}
            valueSlider['sliderClientTop'] = valueUsageChange
            this.clientTopServices.emitChangeSlider(valueSlider)
        } else {
            this.valChange = 0
            const valueSlider: any = {}
            valueSlider['sliderClientTop'] = 0
            this.clientTopServices.emitChangeSlider(valueSlider)
        }
    }

    initjsonMovie(json) {
        this.jsonOther['face-1'] = (json['face-1'] != undefined) ? json['face-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['face-2'] = (json['face-2'] != undefined) ? json['face-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['face-3'] = (json['face-3'] != undefined) ? json['face-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['face-4'] = (json['face-4'] != undefined) ? json['face-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['face-5'] = (json['face-5'] != undefined) ? json['face-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['face-6'] = (json['face-6'] != undefined) ? json['face-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['face-all'] = (json['face-all'] != undefined) ? json['face-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonOther['other-1'] = (json['other-1'] != undefined) ? json['other-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['other-2'] = (json['other-2'] != undefined) ? json['other-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['other-3'] = (json['other-3'] != undefined) ? json['other-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['other-4'] = (json['other-4'] != undefined) ? json['other-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['other-5'] = (json['other-5'] != undefined) ? json['other-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['other-6'] = (json['other-6'] != undefined) ? json['other-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['other-all'] = (json['other-all'] != undefined) ? json['other-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonOther['movie-1'] = (json['movie-1'] != undefined) ? json['movie-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['movie-2'] = (json['movie-2'] != undefined) ? json['movie-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['movie-3'] = (json['movie-3'] != undefined) ? json['movie-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['movie-4'] = (json['movie-4'] != undefined) ? json['movie-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['movie-5'] = (json['movie-5'] != undefined) ? json['movie-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['movie-6'] = (json['movie-6'] != undefined) ? json['movie-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['movie-all'] = (json['movie-all'] != undefined) ? json['movie-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonOther['xp-1'] = (json['xp-1'] != undefined) ? json['xp-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['xp-2'] = (json['xp-2'] != undefined) ? json['xp-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['xp-3'] = (json['xp-3'] != undefined) ? json['xp-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['xp-4'] = (json['xp-4'] != undefined) ? json['xp-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['xp-5'] = (json['xp-5'] != undefined) ? json['xp-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['xp-6'] = (json['xp-6'] != undefined) ? json['xp-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['xp-all'] = (json['xp-all'] != undefined) ? json['xp-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonOther['tooth-right'] = (json['tooth-right'] != undefined) ? json['tooth-right'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['tooth-front'] = (json['tooth-front'] != undefined) ? json['tooth-front'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['tooth-left'] = (json['tooth-left'] != undefined) ? json['tooth-left'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['tooth-upper'] = (json['tooth-upper'] != undefined) ? json['tooth-upper'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['tooth-overjet'] = (json['tooth-overjet'] != undefined) ? json['tooth-overjet'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['tooth-lower'] = (json['tooth-lower'] != undefined) ? json['tooth-lower'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['tooth-all'] = (json['tooth-all'] != undefined) ? json['tooth-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonOther['aligner-right'] = (json['aligner-right'] != undefined) ? json['aligner-right'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['aligner-front'] = (json['aligner-front'] != undefined) ? json['aligner-front'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['aligner-left'] = (json['aligner-left'] != undefined) ? json['aligner-left'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['aligner-upper'] = (json['aligner-upper'] != undefined) ? json['aligner-upper'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['aligner-overjet'] = (json['aligner-overjet'] != undefined) ? json['aligner-overjet'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['aligner-lower'] = (json['aligner-lower'] != undefined) ? json['aligner-lower'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonOther['aligner-all'] = (json['aligner-all'] != undefined) ? json['aligner-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.arrayTypeImage = jQuery.extend(true, [], this.defaultArrayTypeImage)
        this.getArrRegistrationOther(this.jsonOther)
    }

    getArrRegistrationOther(arrTooth) {
        this.arrRegistrationOther = arrTooth[this.tabName]
        this.getShowStatus(this.arrRegistrationOther)
    }

    swapMatrix(index, nextIndex) {
        const tmp = this.matrixImage[index]
        const swapTmp = this.matrixImage[nextIndex]
        this.matrixImage[index] = swapTmp
        this.matrixImage[nextIndex] = tmp
    }

    swapArrImage(index, nextIndex) {
        const tmp = this.arrImage[index]
        const swapTmp = this.arrImage[nextIndex]
        this.arrImage[index] = swapTmp
        this.arrImage[nextIndex] = tmp
    }

    swapArrImageStyle(index, nextIndex) {
        const tmp = this.arrStyleImage[index]
        const swapTmp = this.arrStyleImage[nextIndex]
        this.arrStyleImage[index] = swapTmp
        this.arrStyleImage[nextIndex] = tmp
    }

    swapArr(index, nextIndex) {
        this.swapMatrix(index, nextIndex)
        this.swapArrImage(index, nextIndex)
        this.swapArrImageStyle(index, nextIndex)
        const tmp = this.arrRegistrationOther[index]
        const tmpRight = this.arrRegistrationOther[nextIndex]
        this.arrRegistrationOther[index] = tmpRight
        this.arrRegistrationOther[nextIndex] = tmp
        switch (this.TabRegistrationOtherClass) {
            case 'option_0':
                this.jsonOther['other-all'] = this.arrRegistrationOther
                let i: any
                let left: any
                let right: any
                const countIndex = index + 1
                switch (countIndex) {
                    case 1:
                        i = 'other-1'
                        right = 'other-2'
                        break
                    case 2:
                        left = 'other-1'
                        i = 'other-2'
                        right = 'other-3'
                        break
                    case 3:
                        left = 'other-2'
                        i = 'other-3'
                        right = 'other-4'
                        break
                    case 4:
                        left = 'other-3'
                        i = 'other-4'
                        right = 'other-5'
                        break
                    case 5:
                        left = 'other-4'
                        i = 'other-5'
                        right = 'other-6'
                        break
                    case 6:
                        left = 'other-5'
                        i = 'other-6'
                        break
                }
                if (index > nextIndex) {
                    this.jsonOther[left][0] = tmp
                    this.jsonOther[i][0] = tmpRight
                } else {
                    this.jsonOther[i][0] = tmpRight
                    this.jsonOther[right][0] = tmp
                }
                break
            case 'option_1':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonOther['other-all'][0] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonOther['other-all'][0] = tmp3
                }
                this.jsonOther['other-1'] = this.arrRegistrationOther
                break
            case 'option_2':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonOther['other-all'][1] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonOther['other-all'][1] = tmp3
                }
                this.jsonOther['other-2'] = this.arrRegistrationOther
                break
            case 'option_3':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonOther['other-all'][2] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonOther['other-all'][2] = tmp3
                }
                this.jsonOther['other-3'] = this.arrRegistrationOther
                break
            case 'option_4':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonOther['other-all'][3] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonOther['other-all'][3] = tmp3
                }
                this.jsonOther['other-4'] = this.arrRegistrationOther
                break
            case 'option_5':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonOther['other-all'][4] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonOther['other-all'][4] = tmp3
                }
                this.jsonOther['other-5'] = this.arrRegistrationOther
                break
            case 'option_6':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonOther['other-all'][5] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonOther['other-all'][5] = tmp3
                }
                this.jsonOther['other-6'] = this.arrRegistrationOther
                break
            default:
                break
        }
        this.arrAllOther[this.index] = this.jsonOther
        this.emitArrAll['registration'] = this.arrAllOther
        this.emitArrAll['checkChange'] = true
        this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
        this.getShowStatus(this.arrRegistrationOther)
    }

    moveRight(index) {
        const nextIndex: any = index + 1
        this.swapArr(index, nextIndex)
    }

    moveLeft(index) {
        const nextIndex: any = index - 1
        this.swapArr(index, nextIndex)
    }

    onDeleteImage(index) {
        this.matrixServices.removePhoto(index)
        const tmpNone: any = {}
        tmpNone['id'] = ''
        this.arrRegistrationOther[index] = tmpNone
        switch (this.TabRegistrationOtherClass) {
            case 'option_0':
                this.jsonOther['other-all'] = this.arrRegistrationOther
                const countIndex = index + 1
                const i: any = 'other-' + countIndex
                const tmp: any = {}
                tmp['id'] = ''
                this.jsonOther[i][0] = tmp
                break
            case 'option_1':
                if (index == 0) {
                    const tmp1: any = {}
                    tmp1['id'] = ''
                    this.jsonOther['other-all'][0] = tmp1
                }
                this.jsonOther['other-1'] = this.arrRegistrationOther
                break
            case 'option_2':
                if (index == 0) {
                    const tmp1: any = {}
                    tmp1['id'] = ''
                    this.jsonOther['other-all'][1] = tmp1
                }
                this.jsonOther['other-2'] = this.arrRegistrationOther
                break
            case 'option_3':
                if (index == 0) {
                    const tmp1: any = {}
                    tmp1['id'] = ''
                    this.jsonOther['other-all'][2] = tmp1
                }
                this.jsonOther['other-3'] = this.arrRegistrationOther
                break
            case 'option_4':
                if (index == 0) {
                    const tmp1: any = {}
                    tmp1['id'] = ''
                    this.jsonOther['other-all'][3] = tmp1
                }
                this.jsonOther['other-4'] = this.arrRegistrationOther
                break
            case 'option_5':
                if (index == 0) {
                    const tmp1: any = {}
                    tmp1['id'] = ''
                    this.jsonOther['other-all'][4] = tmp1
                }
                this.jsonOther['other-5'] = this.arrRegistrationOther
                break
            case 'option_6':
                if (index == 0) {
                    const tmp1: any = {}
                    tmp1['id'] = ''
                    this.jsonOther['other-all'][5] = tmp1
                }
                this.jsonOther['other-6'] = this.arrRegistrationOther
                break
            default:
                break
        }
        this.uploadImageForm.reset()
        this.matrixServices.removePhoto(index)
        this.arrAllOther[this.index] = this.jsonOther
        this.emitArrAll['registration'] = this.arrAllOther
        this.emitArrAll['checkChange'] = true
        this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
        this.getShowStatus(this.arrRegistrationOther)
    }

    getShowStatus(arr: any[] = []) {
        this.arrShowStatus = []
        this.matrixImage = []
        this.arrImage = []
        this.arrStyleImage = []
        if (arr && arr.length > 0) {
            arr.forEach((el, i) => {
                if (el != undefined && el['id'] != undefined && el['id'] != '') {
                    let url
                    if (this.arrayTypeImage[i] != 'other') {
                        url = getImageRedirectUrl(el['id'] + '?type=' + this.arrayTypeImage[i])
                    } else {
                        url = getImageRedirectUrl(el['id'])
                    }
                    this.arrIds[i] = el['id']
                    this.arrImage.push(url)
                    this.arrShowStatus.push(true)
                } else {
                    this.arrImage.push(undefined)
                    this.arrShowStatus.push(false)
                }
                if (el != undefined && el['matrix'] != undefined) {
                    this.matrixImage.push(el['matrix'])
                } else {
                    this.matrixImage.push([1, 0, 0, 1])
                }
                if (el != undefined && el['style'] != undefined) {
                    this.arrStyleImage.push(el['style'])
                } else {
                    this.arrStyleImage.push({})
                }
            })
            this.getStyleMatrix(this.matrixImage, this.arrImage, this.arrRegistrationOther)
        }
        // this.resetMatrixMovedUpPage();
    }

    getStyleMatrix(matrixImage, arrImage, arrRegistration) {
        const _thi = this
        setTimeout(() => {
            arrRegistration.forEach(function(el, item) {
                const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + item)
                const imageId: HTMLElement = document.getElementById('imageId' + item)
                _thi.matrixServices.loadSizeImage(imageId, imageWrapper, item, matrixImage, arrImage, arrRegistration)
            })
        }, 200)
    }

    toggleTabRegistrationOtherItem(id, event) {
        this.uploadImageForm.reset()
        this.TabRegistrationOtherClass = id
        switch (id) {
            case 'option_0':
                this.tabName = 'other-all'
                break
            case 'option_1':
                this.tabName = 'other-1'
                break
            case 'option_2':
                this.tabName = 'other-2'
                break
            case 'option_3':
                this.tabName = 'other-3'
                break
            case 'option_4':
                this.tabName = 'other-4'
                break
            case 'option_5':
                this.tabName = 'other-5'
                break
            case 'option_6':
                this.tabName = 'other-6'
                break
            default:
                this.tabName = 'other-all'
                break
        }
        this.arrayTypeImage = jQuery.extend(true, [], this.defaultArrayTypeImage)
        this.tabUploadImage = undefined
        this.emitTabName['tabName'] = this.tabName
        this.arrRegistrationOther = this.jsonOther[this.tabName]
        this.clientTopServices.emitChangeTabName(this.emitTabName)
        this.getShowStatus(this.arrRegistrationOther)
    }

    getUrlImage(item, url) {
        if (url == '') {
            if (undefined !== this.arrRegistrationOther && this.arrRegistrationOther.length > 0) {
                const tmp: any = this.arrRegistrationOther[item]
                if (tmp != undefined && tmp['id'] != '') {
                    return getImageRedirectUrl(tmp['id'])
                }
            }
            return ''
        } else {
            return url
        }
    }

    setArrClientTop(data, index, idImage) {
        this.arrRegistrationOther = data
        this.getShowStatus(this.arrRegistrationOther)
        switch (this.tabUploadImage) {
            case 'option_0':
                this.jsonOther['other-all'] = data
                const countIndex: any = index + 1
                const i: any = 'other-' + countIndex
                this.jsonOther[i][0] = idImage
                break
            case 'option_1':
                if (index == 0) {
                    const tmp3: any = idImage
                    this.jsonOther['other-all'][0] = tmp3
                }
                this.jsonOther['other-1'] = data
                break
            case 'option_2':
                if (index == 0) {
                    const tmp3: any = idImage
                    this.jsonOther['other-all'][1] = tmp3
                }
                this.jsonOther['other-2'] = data
                break
            case 'option_3':
                if (index == 0) {
                    const tmp3: any = idImage
                    this.jsonOther['other-all'][2] = tmp3
                }
                this.jsonOther['other-3'] = data
                break
            case 'option_4':
                if (index == 0) {
                    const tmp3: any = idImage
                    this.jsonOther['other-all'][3] = tmp3
                }
                this.jsonOther['other-4'] = data
                break
            case 'option_5':
                if (index == 0) {
                    const tmp3: any = idImage
                    this.jsonOther['other-all'][4] = tmp3
                }
                this.jsonOther['other-5'] = data
                break
            case 'option_6':
                if (index == 0) {
                    const tmp3: any = idImage
                    this.jsonOther['other-all'][5] = tmp3
                }
                this.jsonOther['other-6'] = data
                break
            default:
                break
        }
        this.arrAllOther[this.index] = this.jsonOther
        this.emitArrAll['registration'] = this.arrAllOther
        this.emitArrAll['checkChange'] = true
        this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
    }

    uploadFileEnd(event) {
        this.tabUploadImage = this.TabRegistrationOtherClass
        this.clientTopServices.checkChangeData = true
        const jsonFlip: any = {
            'horizontalFlip': 1,
            'verticalFlip': 1,
        }
        const i = event.item
        this.matrixServices.arrFlip[i] = jsonFlip
        const tmp: any = {}
        tmp['id'] = event.success['hash']
        tmp['matrix'] = [1, 0, 0, 1]
        this.arrRegistrationOther[i] = tmp
        this.matrixImage[i] = [1, 0, 0, 1]
        const url = getImageRedirectUrl(event.success['hash'])
        this.arrImage[i] = url
        this.setArrClientTop(this.arrRegistrationOther, i, tmp)
        this.arrLoading[i] = false
    }

    onStartUpload(event) {
        let listUpload: any[] = event.listUpload
        this.animationDuration = event.animationDuration
        for (let index = 0; index < listUpload.length; index++) {
            if (listUpload[index]) {
                this.arrLoading[listUpload[index]] = true
            }
        }
    }

    onUploadError() {
        this.uploadImageForm.reset()
    }

    handleFileInput(files: FileList, index, event) {
        if (event.target.files && event.target.files[0]) {
            this.tabUploadImage = this.TabRegistrationOtherClass
            const arrUploadImage: any[] = this.arrRegistrationOther
            const reader = new FileReader()

            reader.readAsDataURL(event.target.files[0])
            const excrptFile: any = 'image/'
            const tmpFile: any = files[0]
            const typeFile: String = tmpFile['type']
            if (typeFile.includes(excrptFile)) {
                this.animationDuration = 2800
                this.arrLoading[index] = true
                reader.onload = (event: any) => {
                    this.arrShowStatus[index] = true
                    this.getUrlImage(0, event.target.result)
                }
                this.authData.authToken().then(tokenReNew => {
                    this.restApi.postFile(files.item(0), tokenReNew).subscribe(
                        success => {
                            const jsonFlip: any = {
                                'horizontalFlip': 1,
                                'verticalFlip': 1,
                            }
                            this.arrLoading[index] = false
                            this.matrixServices.arrFlip[index] = jsonFlip
                            const tmp: any = {}
                            tmp['id'] = success['hash']
                            tmp['matrix'] = [1, 0, 0, 1]
                            arrUploadImage[index] = tmp
                            this.matrixImage[index] = [1, 0, 0, 1]
                            const url = getImageRedirectUrl(success['hash'])
                            this.arrImage[index] = url
                            this.setArrClientTop(arrUploadImage, index, tmp)
                            this.resetFile(index)
                        },
                    )
                })
            } else {
                this.uploadImageForm.reset()
            }
        } else {
            this.uploadImageForm.reset()
        }
    }

    resetFile(item) {
        $('#fileUpload_' + item).val('');
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/top/registration/registrationOther/modal-client-detail-registraion-other.component.ts